import { mobileMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import {
  Container as PopularPropertiesHome,
  PopularPropertiesLink,
  Title,
} from '@propertypal/web-ui/src/home/PopularPropertiesHome.style';
import { Benefit } from '@propertypal/web-ui/src/jumbotrons/NewHomesJumboTron.style';
import GridContainer from '@propertypal/web-ui/src/property/PropertyGrid.style';
import styled from 'styled-components';

export const HandPickedContainer = styled.div`
  max-width: 1310px;
  margin: 35px auto;

  ${PopularPropertiesHome} {
    margin: 0 auto;
    padding-bottom: 15px;
  }

  ${Title} {
    margin-bottom: 0px;
    font-size: 25px;
    font-weight: 600;
  }

  ${PopularPropertiesLink} {
    font-weight: normal;
    font-size: 17px;
  }

  ${GridContainer} {
    margin: 0;
    padding-top: 15px;
    padding-bottom: 15px;
  }
`;

export const NewHomesContent = styled.div`
  margin: 0px auto 60px auto;
  max-width: 1280px;
  padding: 0 15px;
`;

export const ShowHomeWrapper = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #fcdbe2;
`;

export const ShowHomeContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (min-width: 769px) {
    flex-direction: row;
    justify-content: space-between;

    > :not(:last-child) {
      margin-right: 16px;
    }
  }

  @media (${tabletMax}) {
    > :not(:last-child) {
      margin-bottom: 16px;
    }
  }

  @media (${mobileMax}) {
    h2 {
      font-size: 20px;
    }
    button p {
      font-size: 14px;
    }
  }
`;

export const ShowHomeViewings = styled.div`
  display: flex;
  align-items: center;

  h3 {
    font-weight: normal;
    font-size: 20px;
  }

  > :not(:last-child) {
    margin-right: 16px;
  }

  @media (${mobileMax}) {
    h3 {
      font-size: 16px;
    }
  }
`;

export const Tip = styled(Benefit)`
  margin-top: 40px;

  h4,
  p {
    margin-top: 8px;
  }
`;
